module.exports = __webpack_public_path__ + "img/bg.00df191b.png";